import {
  Icons,
  Tooltip,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import type { BoxProps } from '@cast/design-system';

export const TypeNotSupportedWrapper = ({ children, ...props }: BoxProps) => {
  return (
    <Tooltip
      title={
        <Stack direction="row" gap={4} alignItems="center">
          <Icons.Lock size={16} weight="fill" />
          <Typography variant="P12R" noWrap>
            Horizontal rightsizing is not available for this workload type
          </Typography>
        </Stack>
      }
      color="secondary"
      sx={{
        maxWidth: 'unset',
      }}
      placement="top"
    >
      <Box
        position="relative"
        width="max-content"
        display="flex"
        alignItems="center"
        py={2}
        {...props}
      >
        {children}
        <Icons.Lock
          size={10}
          weight="fill"
          css={{
            position: 'absolute',
            top: 0,
            right: -2,
            pointerEvents: 'none',
            color: tokens.theme.fg.structural.secondary,
          }}
        />
      </Box>
    </Tooltip>
  );
};
